document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.banner-kit')
  const bannerImage = banner?.querySelector('.banner-kit__image')

  if(banner && bannerImage) {
    const resize = () => {
      banner.setAttribute('style', `--height: ${bannerImage.clientHeight}px` )
    }

    window.addEventListener('resize', resize)

    resize()
  }
})